const clinicNoteItemTypes = {
  new: "new",
  view: "view",
  edit: "edit",
};

export default clinicNoteItemTypes;
